<template>
  <div class="body">
    <div v-if="isLoaded">
      <!--------- first-section ------->
      <div class="first-section">
        <div class="title_first">
          <h3>Skill Court Overview</h3>
          <h3
            class="timeNow"
            style="width: 66px; color: #f7941e;
          font-weight: 600"
          >
            {{ currentTime }}
          </h3>
        </div>
        <div class="first-container box">
          <div class="header">
            <div class="labels-div">
              <div
                style="display: flex; justify-content: center; column-gap: 8px"
              >
                <span class="fields-label">Available</span>
                <span class="square available-color"></span><br />
              </div>
              <div
                style="display: flex; justify-content: center; column-gap: 8px"
              >
                <span class="fields-label">Occupied</span>
                <span class="square occupied-color"></span><br />
              </div>

              <div
                style="display: flex; justify-content: center; column-gap: 8px"
              >
                <span class="fields-label">Maintenance</span>
                <span class="square in_maintenance-color"></span>
              </div>
            </div>

            <SkillcourtAmsterdamLayout
              v-if="getSelectedCourt.id === 4"
              :zones="getAllFields"
            />
            <SkillcourtRotterdamLayout
              v-if="getSelectedCourt.id === 1"
              :zones="getAllFields"
            />
            <SkillcourtEuroParcsLayout
              v-if="getSelectedCourt.id === 5"
              :zones="getAllFields"
            />
          </div>

          <div class="SCSummary">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">Number</th>
                  <th scope="col">Name of section</th>
                  <th scope="col">Available</th>
                  <th scope="col">Booked from</th>
                  <th scope="col">Free from</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in getAllFields" :key="item.id">
                  <td :class="{ BookedClass: item.is_occupied === true }">
                    {{ item.id }}
                  </td>
                  <td :class="{ BookedClass: item.is_occupied === true }">
                    {{ item.name }}
                  </td>
                  <td
                    :class="{ BookedClass: item.is_occupied === true }"
                    v-if="item.is_occupied"
                  >
                    Booked
                  </td>
                  <td
                    :class="{ BookedClass: item.is_occupied === true }"
                    v-if="!item.is_occupied"
                  >
                    Free
                  </td>
                  <td :class="{ BookedClass: item.is_occupied === true }">
                    {{ getBookedFrom(item.id) }}
                  </td>
                  <td :class="{ BookedClass: item.is_occupied === true }">
                    {{ getFreeFrom(item.id) }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!--------- second-section ------->
      <div class="second-section">
        <div class="title">
          <h3>Skill Court Overview</h3>
          <label for="time" style="margin: 0 0 0 50px">Time</label>
          <select
            id="view-date"
            name="time"
            v-model="timePeriodModel"
            @change="changedAggregation"
          >
            <option value="total">all</option>
            <option value="week">week</option>
            <option value="month">month</option>
            <option value="year">year</option>
          </select>
        </div>
        <div class="second-container box">
          <div class="SCSummary">
            <table class="table">
              <thead>
                <tr>
                  <th scope="col">Number</th>
                  <th scope="col">Name of section</th>
                  <th scope="col">Games</th>
                  <th scope="col">Total time of use</th>
                  <th scope="col">Avg time of use</th>
                  <th scope="col">Exercise type</th>
                  <th scope="col">Popular exercise</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="getAllFieldsOverview.data.length == 0">
                  <td>No data for the selected period</td>
                </tr>
                <tr
                  v-else
                  v-for="(item, id) in getAllFieldsOverview.data"
                  :key="id"
                >
                  <td>{{ id + rowNumber }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ item.selected }}</td>
                  <td>{{ getFormattedTime(item.total_time_of_use) }}</td>
                  <td>{{ getAverageFormattedTime(item.average_use_time) }}</td>
                  <td>{{ item.is_skill_game_multiplayer }}</td>
                  <td>{{ item.skill_game_title }}</td>
                </tr>
              </tbody>
            </table>
            <PaginationNavigation
              @onNext="onNextPage"
              @onPrev="onPrevPage"
              :page="pageNumber"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="loader"></div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import SkillcourtEuroParcsLayout from "../components/SkillcourtEuroParcsLayout.vue";
import SkillcourtAmsterdamLayout from "../components/SkillcourtAmsterdamLayout.vue";
import SkillcourtRotterdamLayout from "../components/SkillcourtRotterdamLayout.vue";
import { FETCH_FIELDS, FETCH_FIELDS_OVERVIEW } from "../store/actions.type";

// import SkillcourtRotterdamLayout from "../components/SkillcourtRotterdamLayout.vue";
import getFormattedTime from "../mixins/formatTime";
import getAverageFormattedTime from "../mixins/formatTime";
import prevPage from "../mixins/pagination";
import nextPage from "../mixins/pagination";
import PaginationNavigation from "../components/PaginationNavigation.vue";
export default {
  mixins: [getFormattedTime, prevPage, nextPage, getAverageFormattedTime],
  name: "SkillCourt",
  data() {
    return {
      isLoaded: false,

      BookedClass: "",

      currentTime: null,
      weekArray: [],
      monthArray: [],
      yearArray: [],
      timePeriodModel: "week",
      resultsByDate: this.$store.state.skillgameLogs,
      secondTableData: [],
      pageNumber: 1,
      rowNumber: 1,
    };
  },
  created() {
    this.currentTime = moment()
      .add(this.delay, "s")
      .format("HH:mm:ss");
    setInterval(() => this.updateCurrentTime(), 1 * 1000);
  },
  mounted() {
    this.fetchData();
    this.changeData;
    this.resultsByDate = this.changeData;
  },
  computed: {
    ...mapGetters([
      "takeAllFields",
      "takeSkillgames",
      "getSkillgameLogs",
      "getSelectedCourt",
      "getAllFields",
      "getAllFieldsOverview",
    ]),
  },
  watch: {
    timePeriodModel() {
      this.resultsByDate = this.changeData;
    },

    getSelectedCourt() {
      this.fetchData();
    },
  },
  methods: {
    async onNextPage() {
      this.pageNumber = this.nextPage(this.pageNumber);

      await this.$store.dispatch(FETCH_FIELDS_OVERVIEW, {
        courtId: this.getSelectedCourt.id,
        time: this.timePeriodModel,
        page: this.pageNumber,
      });

      if (this.getAllFieldsOverview.from) {
        this.rowNumber = this.getAllFieldsOverview.from;
      }
    },
    async onPrevPage() {
      this.pageNumber = this.prevPage(this.pageNumber);

      await this.$store.dispatch(FETCH_FIELDS_OVERVIEW, {
        courtId: this.getSelectedCourt.id,
        time: this.timePeriodModel,
        page: this.pageNumber,
      });

      this.rowNumber = this.getAllFieldsOverview.from;
    },
    async changedAggregation() {
      this.pageNumber = 1;
      this.rowNumber = 1;
      await this.$store.dispatch(FETCH_FIELDS_OVERVIEW, {
        courtId: this.getSelectedCourt.id,
        time: this.timePeriodModel,
        page: this.pageNumber,
      });
    },
    async fetchData() {
      await this.$store.dispatch(FETCH_FIELDS, {
        courtId: this.getSelectedCourt.id,
      });
      await this.$store.dispatch(FETCH_FIELDS_OVERVIEW, {
        courtId: this.getSelectedCourt.id,
        time: this.timePeriodModel,
        page: this.pageNumber,
      });

      this.isLoaded = true;
    },

    getBookedFrom(fieldId) {
      for (let index = 0; index < this.getAllFields.length; index++) {
        if (this.getAllFields[index].id === fieldId) {
          if (this.getAllFields[index].is_occupied) {
            return moment(this.getAllFields[index].updated_at).format(
              "HH:mm:ss"
            );
          } else {
            return "-";
          }
        }
      }
    },
    getFreeFrom(fieldId) {
      for (let index = 0; index < this.getAllFields.length; index++) {
        if (this.getAllFields[index].id === fieldId) {
          if (!this.getAllFields[index].is_occupied) {
            return moment(this.getAllFields[index].updated_at).format(
              "D  MMM  HH:mm"
            );
          } else {
            return "-";
          }
        }
      }
    },
    updateCurrentTime() {
      this.currentTime = moment().format("HH:mm:ss");
    },
  },
  components: {
    SkillcourtRotterdamLayout,
    SkillcourtAmsterdamLayout,
    SkillcourtEuroParcsLayout,
    PaginationNavigation,
  },
};
</script>

<style lang="scss" scoped>
.body {
  display: flex;
  flex-direction: column;
  width: 92%;
  margin: 0px auto 20px auto;

  font-family: Montserrat-Regular;
}
.box {
  background-color: #383838;
  box-shadow: 3px 3px 10px 0 rgba(41, 41, 41, 0.6);
}

/* /////////////// class="first-section" /////////////// */
.first-section {
  h3 {
    margin: 37px 0 15px 0;
  }
}
.first-container {
  height: 100%;
  width: 100%;
  margin: 0px auto;
}

.header {
  display: flex;
  flex-direction: row;
  row-gap: 1rem;
  background-color: #383838;
  padding: 50px 0 0 0;
  margin: 10px 10px auto;
}

@media (min-width: 768px) {
  .header {
    flex-flow: row nowrap;
  }
  .header > div {
    width: 100%;
  }
  .header > .realTime {
    order: 1;
  }
  .header > .fields--block {
    order: 2;
  }
}

@media (min-width: 576px) {
  .header {
    flex-flow: column wrap;
  }
}

.labels-div {
  display: flex;
  flex-direction: row;
  background-color: #383838;
  align-items: center;
  /* width: 140px !important; */
}

.labels-div > div {
  display: flex;
  justify-content: space-around;
  align-self: center;
  justify-self: center;
  background-color: #383838;
  width: 100%;
}

.square {
  border-radius: 0;
  width: 18px;
  height: 18px;
  float: right;
}
.available-color {
  border: solid 2px #767676;
}
.occupied-color {
  border: solid 2px #1db75a;
  background-color: #1db75a;
}
.in_maintenance-color {
  border: solid 2px #ffb818;
  background-color: #ffb818;
}
.fields-label {
  float: left;
  background-color: #383838;
}
.green-label {
  margin: 8px 8px 0 0;
}
img {
  display: inline-block;
  margin-left: 50px;
  height: 300px;
  width: 700px;
}
.BookedClass {
  background-color: rgba($color: #ffffff, $alpha: 0.03);
}
.SCSummary {
  height: 430px;
  background-color: #383838;
  padding-top: 50px;
  margin: auto auto 0 0;
}

label {
  font-family: Montserrat-Regular;
  font-size: 14px;
  color: #ffffff;
  display: inline-block;
  opacity: 0.58;
  background-color: #383838 !important;
}
/* /////////////// class="second-section" /////////////// */
.title {
  padding-top: 50px;
  font-family: Montserrat-Regular;
  margin: 0px auto 15px auto;
  width: 95%;
}
.title_first {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: Montserrat-Regular;
  margin: 2rem auto 1rem auto;
  width: 95%;
}

.title_first > h3 {
  margin: 0;
}

#view-date {
  margin: 0 100px 0 5px;
}
select {
  direction: rtl;
  text-align: center !important;
  text-indent: 0%;
}
option {
  direction: ltr !important;
  text-align: left;
}

input[type="search"] {
  width: 329.5px;
  height: 30px;
  opacity: 0.5;
  border-radius: 2px;
  border: solid 1px #ffffff;
  float: right;
}
.second-section {
  padding: 0;
}
.second-container {
  height: 100%;
  width: 100%;
  margin: 0px auto;
}
///////////////////// Table \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

.table {
  border-collapse: collapse;
  width: 100%;
  height: 380px;
  margin: auto;
  color: "#ffffff";
}

th,
td {
  border-bottom: 1px solid #505050;
  background-color: #383838;
  text-align: center;
}
td {
  font-size: 16px;
}
th {
  opacity: 0.7;
  position: sticky;
  top: 0;
  background-color: #383838;
  font-size: 14px;
  font-weight: normal;
}
tr {
  padding-top: 25px;
  font-size: 16px;
  background-color: #383838;
}
.loader {
  border: 10px solid #f3f3f3;
  border-radius: 50%;
  border-top: 10px solid #f7941e;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
  margin: auto;
  position: absolute;
  top: 10%;
  left: 10%;
  bottom: 0;
  right: 0;
}
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

::-webkit-scrollbar {
  width: 6px;
  border-left: 1px solid #e6ecf8;
}

::-webkit-scrollbar-track {
  background: #383838;
  height: 100px;
}
::-webkit-scrollbar-thumb {
  height: 10px;
  border: solid 3px #707070;
  border-radius: 20px;
  padding: 20px;
}
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
